<template>
  <button class="btn btn-default mb-3" @click="refresh">Refresh</button>
</template>

<script>
import { createWidgetMixin } from 'vue-instantsearch'

const connectRefresh = (renderFn, unmountFn) => (widgetParams = {}) => ({
  init() {
    renderFn(
      {
        refresh() {
          console.log('Refreshed', widgetParams)
        },
      },
      true
    )
  },

  render({ instantSearchInstance }) {
    const refresh = instantSearchInstance.refresh.bind(instantSearchInstance)

    renderFn({ refresh }, false)
  },

  dispose() {
    unmountFn()
  },
})

export default {
  name: 'AisStateResults',
  mixins: [createWidgetMixin({ connector: connectRefresh })],
  methods: {
    refresh() {
      this.state.refresh()
    },
  },
}
</script>
